<template lang="pug">
  b-row
    b-card.w-100(no-body)
      div.d-flex(slot="header")
        b-breadcrumb(:items="tree")
        div.ml-auto
          b-button-group.excel-btn-group(v-if="excelAdd")
            div.mr-2
              b-form-file(size="sm", @change="readFile")
            b-button.mr-2(
              size="sm",
              @click="onSubmit"
            ) {{$t('enrollment')}}
            b-button.mr-4(
              v-if="lang === 'en'",
              size="sm",
              type="button",
              variant="info",
              :href="`${Form}/linkmemine_group_form_en.xlsx`", download
            ) {{$t('excel-form')}}
            b-button.mr-4(
              v-else,
              size="sm",
              type="button",
              variant="info",
              :href="`${Form}/linkmemine_group_form_ko.xlsx`", download
            ) {{$t('excel-form')}}
            b-button.mr-2(
              size="sm",
              type="button",
              variant="danger",
              @click="excelCancel"
              ) {{$t('cancel')}}
          b-button-group.excel-btn-group(v-else)
            b-button.mr-2(
              size="sm",
              type="button",
              variant="info",
              @click="addGroup") {{$t('add_group')}}
            b-button.mr-2(
              v-if="!AppState.env.VUE_APP_SCI",
              size="sm",
              type="button",
              variant="info",
              @click="excelAddGroups") {{$t('excel-groups')}}
          b-button-group(size="sm")
            b-button(@click="viewMode = 'list'", :variant="viewMode === 'list' ? 'primary':'secondary'")
              icon(name="list")
            b-button(@click="viewMode = 'icon'", :variant="viewMode === 'icon' ? 'primary':'secondary'")
              icon(name="th-large")
      b-container.mt-4(v-if="viewMode === 'list'")
        b-list-group.mb-4
          b-list-group-item(
            v-if="groupPk",
            :order="-1",
            key="upside",
            :to="prevLink") ..
          b-list-group-item.d-flex(
            v-for="(group, i) in groupOnPage",
            :order="i",
            :key="group.pk",
            :to="{name: 'groups-sub', params: {groupPk: group.pk}}")
            div.pt-1.pr-4
              icon(name="regular/folder", scale="2", style="color:#c7c7c7")
            div.flex-column.align-items-start
              div {{group.name}}
              div
                small
                  | {{group.manager_name || $t('empty_manager')}}
                  | /
                  | {{group.manager_email || $t('empty_Email')}}
                  | /
                  | {{group.manager_phone || $t('empty_phone')}} /
            div.ml-auto
              router-link.setting(:to="{name: 'group-detail', params: {groupPk: group.pk}}")
                icon(name="cog", scale="1.6")
              | &nbsp;&nbsp;
              span.remove(@click.prevent="removeGroup(group)")
                icon(name="trash", scale="1.6")
      b-container.mt-4.pb-4(v-if="viewMode === 'icon'")
        waterfall(
          :line-gap="140",
          :min-line-gap="140",
          :max-line-gap="220",
          :watch="groupOnPage",
          align="center")
          waterfall-slot.group-item-wrap(
            v-if="groupPk",
            move-class="item-move",
            :width="140",
            :height="120",
            :order="-1",
            key="upside")
            router-link.folder-button(:to="prevLink")
              div.folder-icon: icon(name="regular/folder-open", scale="3")
              div.title ..
          waterfall-slot.group-item-wrap(
            v-for="(group, i) in groupOnPage",
            move-class="item-move",
            :width="140",
            :height="120",
            :order="i",
            :key="group.pk")
            router-link.folder-button(:to="{name: 'groups-sub', params: {groupPk: group.pk}}")
              div.folder-icon: icon(name="regular/folder", scale="3")
              div.title {{group.name}}
              div.updated {{group.update_time | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt)}}
              router-link.setting(:to="{name: 'group-detail', params: {groupPk: group.pk}}")
                icon(name="cog", scale="1.3")
              span.remove(@click.prevent="removeGroup(group)")
                icon(name="trash", scale="1.3")
</template>

<script>
import _ from 'lodash'
import store from '@/api/store'
import {user} from '@/api/access'
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
import {DeviceGroupAPI} from '@/api'
import XLSX from 'xlsx'
import {DeviceGroupsExcelAPI} from '@/api'
import ko from '../../i18n/lang/ko'

export default {
  name: 'grouplist-component',
  components: { Waterfall, WaterfallSlot },
  props: {
    groupPk: {
      type: [String, Number]
    }
  },
  methods: {
    addGroup () {
      const companyKey = user().company_fk
      let group_fk = this.$route.params.groupPk
      let root_group_fk = null
      let group = null
      if (group_fk) {
        group_fk = parseInt(group_fk, 10)
        group = _.find(this.groups, { pk: group_fk })
        if (group) root_group_fk = _.find(this.groups, { pk: group_fk }).root_group_fk
        else group_fk = null
        if (!root_group_fk) root_group_fk = group_fk
      }
      else group_fk = null

      let params = {
        context: group_fk
          ? {title: this.$t('add-group-child'), path: 'add_child_group', args: {name: group.name}}
          : {title: this.$t('add_group'), path: 'add_root_group'},
        limit: 40,
        placeholder: 'name',
        submit: {
          size: 'sm',
          color: 'primary',
          text: 'create'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {
          let params = {
            name: data,
            flag_df_group: false,
            flag_confirm: false,
            group_fk,
            root_group_fk,
            company_fk: companyKey
          }
          DeviceGroupAPI.post('', params)
            .then(resp => {
              if (resp.data.objects.overlap) {
                this.$awn.alert(this.$t('duplication_group_name'))
              } else {
                const group = resp.data.objects
                this.groups.push(group)
                store.update('devices', (update) => {
                  group.has_permission = true
                  update.groups = this.groups
                })
                this.$awn.success(this.$t('created_group'))
              }
            })
        }
      })
    },
    setParent (pk) {
      this.routes.parent = pk
    },
    stopBubble () {},
    removeGroup (group) {
      let params = {
        context: {path: 'confirm_delete_group'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'submit'}
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        DeviceGroupAPI.delete(`${group.pk}`)
          .then(() => {
            let index = _.findIndex(this.groups, v => v.pk === group.pk)
            this.groups.splice(index, 1)
            store.update('devices', ({groups}) => {
              _.remove(groups, v => v.pk === group.pk)
            })
            this.$awn.success(this.$t('deleted_group'))
          })
      })
    },
    excelAddGroups () {
      this.excelAdd = true
    },
    excelCancel () {
      this.excelAdd = false
    },
    readFile(event) { 
      var input = event.target
      var reader = new FileReader()
      let excelFinalValidate = false
      let excelFinalParams = ''
      reader.onload = (e) => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, {type : 'binary'})
        wb.SheetNames.forEach(function(sheetName){
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName],{
            header:0,
            defval:''
          })
          var itemList = JSON.stringify(rowObj)
          // validate group data
          var firDep = {name: "", state: false}
          var secDep = {name: "", state: false}
          var inputDepth
          var params = []
          var addRow = {}
          var excelAddValidate = true
          
          for (var i = 0; i < rowObj.length; i++) {
            var emptyCell = 0 

            for (var j = 0; j < 3; j++) {
              inputDepth = 4 //아무숫자나 넣음..0이아닌 디폴트값......
              if (rowObj[i][Object.keys(rowObj[i])[j]] !== '') {
                inputDepth = j
              }
              //첫 행에 루트그룹 없는 경우 처리
              if (i == 0 && j == 0 && inputDepth !== 0) {
                excelAddValidate = false
              }
              if (inputDepth == 0) {
                addRow.parent_group_name = ""
                addRow.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]

                firDep.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
                firDep.state = true
                secDep.state = false
              }
              else if (inputDepth == 1) {
                addRow.parent_group_name = firDep.name
                addRow.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]

                secDep.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
                firDep.state = true
                secDep.state = true
              }
              else if (inputDepth == 2) {
                // 뎁스 하나 뛰어넘어 입력된 경우 처리
                if (firDep.state && !secDep.state) {
                  excelAddValidate = false
                }
                addRow.parent_group_name = secDep.name
                addRow.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
              }
              else {
                emptyCell++
              }
            }
            if (emptyCell !== 2) {
              excelAddValidate = false
            }
            params.push(addRow)
            addRow = {}
          }


          //그룹이름 중복된 경우 처리
          var inputVal = new Array()
          var overlapVal = new Array()
          var overlapChk = true
          for (var k = 0; k < params.length; k++) {
            inputVal.push(params[k].name)
          }
          for (var l = 0; l < inputVal.length; l++) {
            for (var value in overlapVal) {
              if (overlapVal[value] == inputVal[l]) {
                overlapChk = false
              }
            }
            if (overlapChk) {
              overlapVal.push(inputVal[l])
            }
          }
          if (!overlapChk) {
            excelAddValidate = false
          }


          params = JSON.stringify(params)
          excelFinalValidate = excelAddValidate
          excelFinalParams = params
        })
        //Vue Component에 저장
        this.excelAddValidate = excelFinalValidate 
        this.excelAddParams = excelFinalParams
      }
      reader.readAsBinaryString(input.files[0])
    },
    onSubmit() {
      this.excelAdd = false
      if (this.excelAddValidate) {
        DeviceGroupsExcelAPI.post('', this.excelAddParams)
          .then(resp => {
            let total = resp.data.objects.total
            let failure = resp.data.objects.failure

            DeviceGroupAPI.get('')
              .then(resp => {
                const group = resp.data.objects
                this.groups = group.reverse()
                store.update('devices', (update) => {
                  group.has_permission = true
                  update.groups = this.groups
                })
                this.$awn.success(this.$t('excel_group_submit', {total, failure}))
              })
          }).catch(e => {
            console.log(e)
          })
      } else {
        this.$awn.alert(this.$t('excel_group_fail'))
      }
    }
  },
  computed: {
    groupOnPage () {
      let groups = this.groups
      if (this.groupPk) {
        let fk = parseInt(this.groupPk, 10)
        groups = _.filter(groups, { group_fk: fk })
      } else {
        groups = _.filter(groups, { group_fk: null })
      }
      return groups
    },
    tree () {
      let tree = []
      if (!this.groups.length) return []
      const addTreeItem = (pk) => {
        let current = _.find(this.groups, { pk })
        if (!current) return
        tree.unshift({
          text: current.name,
          to: { name: 'groups-sub', params: {groupPk: pk} }
        })
        if (current.group_fk) addTreeItem(current.group_fk)
      }
      if (this.groupPk) {
        addTreeItem(parseInt(this.groupPk, 10))
      }
      tree.unshift({
        text: 'ROOT',
        to: { name: 'groups' }
      })
      return tree
    },
    prevLink () {
      if (this.groupPk) {
        let current = _.find(this.groups, { pk: parseInt(this.groupPk, 10) })
        if (current && current.group_fk) return {name: 'groups-sub', params: {groupPk: current.group_fk}}
        return {name: 'groups'}
      } else return {name: 'groups'}
    }
  },
  created () {
    let stored = store.get('devices')
    if (stored) {
      this.groups = stored.groups
    }
    let langStore = store.get('lang')
    this.lang = langStore
  },
  data () {
    return {
      groups: [],
      viewMode: 'list',
      excelAdd: false,
      excelAddValidate: true,
      excelAddParams: '',
      Form: `${this.AppState.Path.download}/form`,
      lang: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  background-color: transparent;
  margin: 0;
  padding: 0;
}
.group-item-wrap {
  text-align: center;
}
.folder-button {
  position: relative;
  display: block;
  width: 140px; height: 120px;
  color: #99bdbb;
  margin: 0 auto;
  padding-top: 20px;
  border: 1px solid #ebebeb;
  background-color: #ebebeb;

  .setting {
    position: absolute;
    top: 10px; right: 34px;
    color: #d4d4d4;
    transition: color 300ms;
    &:hover {
      color: #888;
    }
  }

  .remove {
    position: absolute;
    top: 10px; right: 10px;
    color: #d4d4d4;
    transition: color 300ms;
    &:hover {
      color: #ef7e7e;
    }
  }
}
.setting {
  // position: absolute;
  // top: 10px; right: 10px;
  color: #ababab;
  transition: color 300ms;
  &:hover {
    color: #888;
  }
}

.remove {
  color: #ababab;
  transition: color 300ms;
  &:hover {
    color: #ef7e7e;
  }
}

.list-group-item.active {
  background-color: #fff;
  color: #495057;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.excel-btn-group .btn{
  border-radius: 0.2rem !important;
}
</style>